// Mutatieverzoek (E2 Selfservice) — 4-status state-machine.
//
// Bron-hiërarchie:
//   - Status-overgangen uit `apps/api/src/routes/selfservice.ts`.
//   - HANDOVER §5.11: monteur dient mutatie in op Employee-veld; HR keurt
//     goed → wijziging actief op Employee in dezelfde transactie.
//
// Workflow:
//   INGEDIEND → GOEDGEKEURD
//             ↘ AFGEKEURD
//             ↘ INGETROKKEN  (medewerker zelf vóór beoordeling)
//   GOEDGEKEURD / AFGEKEURD / INGETROKKEN zijn eindstaten.

import { WorkflowEngine, type WorkflowDefinition } from '../workflow-engine'

/** Mirror van Prisma MutatieStatus enum. */
export type MutatieStatusValue =
  | 'INGEDIEND'
  | 'GOEDGEKEURD'
  | 'AFGEKEURD'
  | 'INGETROKKEN'

export const mutatieWorkflow: WorkflowDefinition<MutatieStatusValue> = {
  name: 'mutatie',
  initial: 'INGEDIEND',
  states: ['INGEDIEND', 'GOEDGEKEURD', 'AFGEKEURD', 'INGETROKKEN'],
  transitions: [
    // HR keurt goed
    {
      from: 'INGEDIEND',
      to: 'GOEDGEKEURD',
      label: 'Goedkeuren',
      rolesAllowed: ['HR', 'ADMIN'],
    },
    // HR keurt af
    {
      from: 'INGEDIEND',
      to: 'AFGEKEURD',
      label: 'Afkeuren',
      rolesAllowed: ['HR', 'ADMIN'],
    },
    // Medewerker trekt zelf in vóór HR-beoordeling
    {
      from: 'INGEDIEND',
      to: 'INGETROKKEN',
      label: 'Intrekken',
    },
  ],
}

/** Engine-instance voor mutatieverzoeken — direct importeerbaar in API-routes. */
export const mutatieEngine = new WorkflowEngine(mutatieWorkflow)
